import React from "react";
import { FileUploader } from "react-drag-drop-files";
import upload from "../../assets/img/Icon awesome-upload.svg";
import files from "../../assets/img/Icon metro-files-empty.svg";
import { ModalInfos } from "../../components/modal";
import Loading from "../../components/Loading"
import { TableError } from "../../components/modalSheetError/tableError";
import axiosInstance from "../../auth/axiosInstance";

const AtualizarPlanilhas = () => {
  const [values, setValues] = React.useState();
  const onChange = (event) => {
    setValues({
      ...values, [event.target.name]:
        event.target.value
    });
  };
  const [file, setFile] = React.useState(null);
  const handleChange = (file) => {
    setFile(file);
  };
  const [initialData, setInitialData] = React.useState([])
  const [label, setlabel] = React.useState('Projeto atualizado com sucesso!')
  const [labelError, setlabelError] = React.useState({ label: 'Erro ao atualizar Projeto!', sugestao: 'Favor revisar nome do Projeto ou Arquivo' })
  const [showModal, setShowModal] = React.useState(false)
  const [showModalError, setShowModalError] = React.useState(false)
  const [showModalErrorLength, setShowModalErrorLength] = React.useState([])
  const [showModal2, setShowModal2] = React.useState(false)

  async function getInitial() {
    await axiosInstance(`filter/Eap_Info/`)
      .then(res => {
        setInitialData(res.data)
      })
  }

  React.useEffect(() => {
    getInitial()
  }, [])

  const [isLoading, setIsLoading] = React.useState(false);

  function callLoading() {
    setIsLoading(true)
    postFile()
  }

  async function postFile() {
    let form = new FormData()
    form.append('file', file)
    let deleted = []
    try {
      await axiosInstance.put(`upload/${values?.sheet?.split(" ")[0]}/${values?.eapId}`, form)
        .then(res => {
          if (res.status === 200) {
            setIsLoading(false)
            setlabel('Projeto atualizado com sucesso!')
            setShowModal(true)
            setValues(undefined)

            const select = document.getElementById("eapId");
            select.value = "option1";
            const select1 = document.getElementById("eapId1");
            select1.value = "option2";
            setFile(null);
            if (res.data.sheet.deleted.length > 0) {
              res.data.sheet.deleted.map(value => {
                deleted.push({
                  tabela: value.match(/dbo.(\w+)/)[1],
                  fields: value.match(/\w+\s=\s\d+|\w+\s=\s'\w{3}'/gm).map(value => value).join(', ')
                })
              })
              setShowModalErrorLength(deleted)
              setShowModalError(true)
            }
          }
        })
    } catch (error) {
      console.log(error)
      setIsLoading(false)
      setlabelError({ label: 'Erro ao atualizar Projeto!', sugestao: 'Favor revisar nome do Projeto ou Arquivo' })
      setShowModal2(true)
    }
  }


  return (
    <section className="bodyatualizar">
      <div style={isLoading ? { display: "flex" } : { display: "none" }} className="absolute-loading">
        < Loading content="Aguarde enquanto atualizamos os valores" />
      </div>
      <section id="modal-new-action" className="modal-new-action">
        <h1 className="montserrat azul w600">Atualizar Dados</h1>
        <p style={{ marginTop: 10 }} className='montserrat'>Para atualizar as planilhas selecione abaixo o seu respectivo tipo e Projeto</p>
        <div className="content-inputs">

          <div className="input-component">
            <div>
              <h3 className="montserrat">Nome do Projeto</h3>
            </div>
            <select name="eapId" id="eapId" onChange={onChange} disabled={values?.sheet?.split(" ")[0].includes("Insumos") ? true : false}>
              <option value="option1">Selecione o Projeto </option>
              {
                initialData.map(value => {
                  return (
                    <option>{value.eapId}</option>
                  )
                })
              }
            </select>
            <h4 className="montserrat">EXEMPLO: SGRUTB01</h4>
          </div>
          <div className="input-component">
            <div>
              <h3 className="montserrat">Aba</h3>
            </div>
            <select name="sheet" id="eapId1" onChange={onChange}>
              <option value="option2">Selecione uma Aba</option>
              <option>Insumos (Geral)</option>
              {/* <option>CPU</option> */}
              <option>EAP (EAP Insumos, CPU...)</option>
            </select>
            <h4 className="montserrat">EXEMPLO: SGRUTB01</h4>
          </div>
          {
            file !== null ?
              <div className="selected-file">
                <img src={files} alt='file' />
                <h4>{file !== null ? file.name : 'Nome do Arquivo sdsdfsdsd'}</h4>
                <h5 onClick={() => setFile(null)}>X</h5>
              </div> :
              <div className="handle-change-content">
                <img src={upload} alt='upload' />
                <FileUploader classes='handle-change' handleChange={handleChange} name="file" />
                <p className="montserrat">Arraste o Documento ou Clique no box para importar</p>
              </div>
          }
        </div>
        <div className="button-okay-modal">
          <button style={{ display: 'none' }} className="montserrat w600">voltar</button>
          <button onClick={() => callLoading()} disabled={(values?.eapId || values?.sheet?.split(" ")[0].includes("Insumos")) && file !== null ? false : true} style={(values?.eapId || values?.sheet?.split(" ")[0].includes("Insumos")) && file !== null ? {} : { backgroundColor: '#ccc', cursor: 'not-allowed' }} className="montserrat w600">Atualizar</button>
        </div>
        <TableError show={showModalError} arr={showModalErrorLength} dowload={setShowModalError} />
      </section>

      <ModalInfos
        checked={showModal}
        onClick={() => setShowModal(false)}
        label={label}
      />

      <ModalInfos
        checked={showModal2}
        error
        onClick={() => setShowModal2(false)}
        label={labelError.label}
        sugestao={labelError.sugestao}
      />
    </section>
  )
}

export default AtualizarPlanilhas
